import { PagerMode } from 'src/app/features/shared/pager/model/pager-show-mode';
import { ITabData, tabData } from 'src/app/features/shared/central-page/models/tab-data';
import { TabName } from 'src/app/infrastructure/services/page-services/models/tab-name';

export const tabStorage = {
    activeGuid: 'activeGuid',
    filterString: 'filterString',
    label: 'label',
    name: 'name',
    page: 'page',
    pagerMode: 'pagerMode',
    scrollPos: 'scrollPos',
    searchFields: 'searchFields',
    searchFieldsActive: 'searchFieldsActive',
    size: 'size',
} as const;

export type TTabStorage = (typeof tabStorage)[keyof typeof tabStorage];

export interface ITabStorage {
    [tabStorage.activeGuid]: string | null;
    [tabStorage.filterString]: string | null;
    [tabStorage.label]: string | null;
    [tabStorage.name]: TabName | null;
    [tabStorage.page]: number | null;
    [tabStorage.pagerMode]: PagerMode | null;
    [tabStorage.scrollPos]: number | null;
    [tabStorage.searchFields]: string[] | null;
    [tabStorage.searchFieldsActive]: string[] | null;
    [tabStorage.size]: number | null;
}

export class TabStorage
    implements ITabStorage
{
    [tabStorage.activeGuid]: string | null = null;
    [tabStorage.filterString]: string | null = null;
    [tabStorage.label]: string | null = null;
    [tabStorage.name]: TabName | null = null;
    [tabStorage.page]: number | null = null;
    [tabStorage.pagerMode]: PagerMode | null = null;
    [tabStorage.scrollPos]: number | null = null;
    [tabStorage.searchFields]: string[] | null = null;
    [tabStorage.searchFieldsActive]: string[] | null = null;
    [tabStorage.size]: number | null = null;

    constructor()
    constructor(data: ITabData | null)
    constructor(data?: ITabData | null) {
        if (!data) return;
        Object.assign(this, TabStorage.merge(this, data));
    }

    static merge(current: ITabStorage, data: ITabData): ITabStorage {
        const next = {...current};
        next[tabStorage.activeGuid]   = data[tabData.activeGuid] ?? null;
        next[tabStorage.filterString] ??= data[tabData.filterString] ?? null;
        next[tabStorage.label]        = data[tabData.label] ?? null;
        next[tabStorage.name]         = data[tabData.name] ?? null;
        next[tabStorage.page]         = data[tabData.page] ?? null;
        next[tabStorage.pagerMode]    = data[tabData.pagerMode] ?? 'hidden';
        next[tabStorage.scrollPos]    ??= data[tabData.scrollPos] ?? null;
        next[tabStorage.searchFields] = data[tabData.searchFields] ?? [];
        next[tabStorage.searchFieldsActive] ??= data[tabData.searchFields] ?? [];
        next[tabStorage.size]         ??= data[tabData.size] ?? 10;
        return next;
    }
}
